import React from 'react';
import { useNavigate } from 'react-router-dom';

const GuestHomeEmptyState = ({ onCreateNew }) => {
  const navigate = useNavigate();

  return (
    <div className="guest-home-empty">
      <h3>Guest access</h3>
      <p>
        You are signed in as a guest on a specific deal. When your agent adds you to a
        transaction, it will appear here automatically.
      </p>
      <p>
        Want to run your own deals in KeyFlo? Create a purchase agreement, listing, or buyer
        agreement after you upgrade to a paid agent plan.
      </p>
      <div className="guest-home-empty-actions">
        <button type="button" className="btn-primary" onClick={onCreateNew}>
          + Create Form
        </button>
        <button
          type="button"
          className="guest-home-empty-button"
          onClick={() => navigate('/profile?upgrade=1')}
        >
          Get Full Access
        </button>
      </div>
    </div>
  );
};

export default GuestHomeEmptyState;
